import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import { reduce } from "lodash";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const today = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function GrossWeek() {
  const [week, setWeek] = useState(today);
  const onWeekChange = useCallback((event) => setWeek(event.target.value), []);

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [playerSelect, setPlayerSelect] = useState(0);
  const onPlayerSelectChange = useCallback(
    (event) => setPlayerSelect(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Week Of"
          type="date"
          value={week}
          size="small"
          onChange={onWeekChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={playerSelect}
                onChange={onPlayerSelectChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Non Zero Bal"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="All Players"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Active Players"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Gross Week Report"
        groupBy="idAgent"
        getUrl={() => "/Reports/Report_Gross_Week"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          DateWeek: week,
          Book: book,
          LineType: lineType,
          Office: office,
          Group: group,
          Distributor: distributor,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          PlayerSelect: playerSelect,
        })}
        getProcess={(data) =>
          data.map((item) => {
            const totalWeek = item.casW + item.sptW + item.horW;
            const total = item.balFwd + totalWeek;

            return {
              ...item,
              total,
              totalWeek,
            };
          })
        }
        getTotals={(data) => ({
          player: "Total",
          name: `${data.length} Players`,
          idCurrency: "1",
          idAgent: "[No Agent]",
          balFwd: reduce(data, (acc, item) => acc + item.balFwd, 0),
          pmts: reduce(data, (acc, item) => acc + item.pmts, 0),
          casW: reduce(data, (acc, item) => acc + item.casW, 0),
          sptW: reduce(data, (acc, item) => acc + item.sptW, 0),
          horW: reduce(data, (acc, item) => acc + item.horW, 0),
          totalWeek: reduce(data, (acc, item) => acc + item.totalWeek, 0),
          total: reduce(data, (acc, item) => acc + item.total, 0),
        })}
        getGlobalTotals={(data) => ({
          player: "Total",
          name: `${data.length} Players`,
          idCurrency: "1",
          idAgent: "[No Agent]",
          balFwd: reduce(data, (acc, item) => acc + item.balFwd, 0),
          pmts: reduce(data, (acc, item) => acc + item.pmts, 0),
          casW: reduce(data, (acc, item) => acc + item.casW, 0),
          sptW: reduce(data, (acc, item) => acc + item.sptW, 0),
          horW: reduce(data, (acc, item) => acc + item.horW, 0),
          totalWeek: reduce(data, (acc, item) => acc + item.totalWeek, 0),
          total: reduce(data, (acc, item) => acc + item.total, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="name">
          Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="balFwd"
          dataFormat={decimalInvertedReportFormatter}
        >
          BalFwd
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="pmts">
          Pmts
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="casW"
          dataFormat={decimalInvertedReportFormatter}
        >
          Casino Week
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="sptW"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sports Week
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="horW"
          dataFormat={decimalInvertedReportFormatter}
        >
          Horses Week
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="totalWeek"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total Week
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default GrossWeek;
